export const lang = {
  
};


export const de = lang;